export { default, SIZE_REPLY, SIZE_COMMENT } from './comment-form';
